import axios from './HTTP'

export default {
  sendWelcomeEmail (userId, callback, errorCallback) {
    axios
      .post('/api/emails.json', {
        user_id: userId,
        email_type: 'welcome'
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

}
